import * as React from 'react';

import { Button } from '@cian/button-component';

interface ISignInButtonProps {
  onClick(): void;
}

export function SignInButton({ onClick }: ISignInButtonProps) {
  return (
    <Button size="M" type="button" color="primary" theme="default" onClick={onClick}>
      Войти
    </Button>
  );
}
